import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchNewCourierCount } from '../api/couriers';
import { setMenuBadgeCount } from '../store/slices/menuSlice';

export function useLoadBadge() {
    const disptach = useDispatch();
    const loadCourierCount = useCallback(
        async (name: string, url: string) => {
            const count = await fetchNewCourierCount(url);
            disptach(setMenuBadgeCount({ name, count }));
            return count;
        },
        [disptach]
    );

    const loadBadges = useCallback(async () => {
        const l1 = await loadCourierCount('Confirmations', '/courier/pending-list');
        const l2 = await loadCourierCount('Activations', '/courier/pre-active-list');
        const l3 = await loadCourierCount('Confirmed', '/courier/confirmed-list');
        disptach(setMenuBadgeCount({ name: 'NewCouriers', count: l1 + l2 + l3 }));
    }, [disptach, loadCourierCount]);

    return {
        loadBadges,
    };
}
